import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'

import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationAccountingUnitCreateRequest, ConfigurationAccountingUnitPatchInBatchRequest } from '@/modules/configurationModule/detail/accounting/billable/units/services/configuration-accounting-billable-unit/configuration-accounting-billable-unit.dto'
import { AccountingUnitResponse } from '@/api/services/billing/common-accounting-unit/billing-common-accounting-unit.dto'

class ConfigurationAccountingBillableUnitsService {
    async create(request: ConfigurationAccountingUnitCreateRequest): Promise<AccountingUnitResponse> {
        const response = await axios.post<AccountingUnitResponse>(
            `/configuration/accountingUnits`,
            request
        )
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel | undefined, params?: CommonParams | undefined): Promise<IResponseAgGrid<AccountingUnitResponse>> {
        const response = await axios.put<IResponseAgGrid<AccountingUnitResponse>>(
            `configuration/accountingUnits`,
            { ...filterModel },
            { params }
        )
        return response.data
    }

    async get(accountingUnitId: number): Promise<AccountingUnitResponse> {
        const response = await axios.get<AccountingUnitResponse>(
            `configuration/accountingUnits/${accountingUnitId}`
        )
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(
            `configuration/accountingUnits/batch`, { data: request }
        )
        return response.data
    }

    async patch(request: ConfigurationAccountingUnitPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(
            `configuration/accountingUnits/batch`,
            request
        )
        return response.data
    }
}

export const configurationAccountingBillableUnitsService = new ConfigurationAccountingBillableUnitsService()
